<nb-card [nbSpinner]="loading">
    <nb-card-body class="py-4">
        <div class="row">
            <div class="col-lg-12">
                <app-shared-filter [filter]="filters" (onChange)="onFiltersChange($event)"></app-shared-filter>
                <div class="events">
                    <div *ngFor="let month of registers" class="events-months">
                        <div class="d-flex align-items-center">
                            <nb-icon icon="calendar-outline"></nb-icon>
                            <p class="events-month__title">{{ month.description }} ({{ month.events.length }})</p>
                        </div>
                        <hr class="divider my-3" />
                        <div class="row">
                            <div class="col-lg-4" *ngFor="let event of month.events">
                                <app-tournament-card [tournament]="event" [isEvent]="true"></app-tournament-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <nb-card class="no-results" *ngIf="!registers && statusCode === 0">
                <nb-card-body>
                    <svg width="84px" height="84px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.5776 14.5419C15.5805 13.53 16.2 12.1373 16.2 10.6C16.2 7.50721 13.6928 5 10.6 5C7.50721 5 5 7.50721 5 10.6C5 13.6928 7.50721 16.2 10.6 16.2C12.1555 16.2 13.5628 15.5658 14.5776 14.5419ZM14.5776 14.5419L19 19M8.5 8.5L12.5 12.5M12.5 8.5L8.5 12.5"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    <p class="paragraph-1">{{ "MESSAGE.RESULT.NO-RESULTS" | translate }}</p>
                </nb-card-body>
            </nb-card>
        </div>
    </nb-card-body>
</nb-card>
